exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-list:hover {\r\n\tcursor: pointer;\r\n\ttransition: .3s linear;\r\n\tbackground-color: rgba(0, 0, 0, .6);\r\n\tcolor: white;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Selector Formularios UNR/ng_usuarios_no_registrados/ng_usuarios_no_registrados/src/app/resources/components/seleccion-anio/seleccion-anio.component.css
// module id = ../../../../../src/app/resources/components/seleccion-anio/seleccion-anio.component.css
// module chunks = main